import { useMemo } from 'react';
import { describeInquiryDates } from '../inquiryPackageModel';

const useInquiryDates = ({ intl, startDate, endDate }) =>
  useMemo(() => describeInquiryDates(intl, startDate, endDate), [intl, startDate, endDate]);

export default useInquiryDates;
